import { PORTAL_ROUTE_PREFIX } from '../../routes/common/constants';

export const HUB_ROUTES = {
    USER_PROFILE: {
        path: '/user/profile',
        name: 'hubs-user-profile',
    },
    REQUESTS_LIST: {
        path: '/user/requests',
        name: 'requests-list',
    },
    CSM_REQUESTS_LIST: {
        path: '/user/requests',
        name: 'csm-requests-list',
    },
    CSM_CONTACT_US: {
        path: '/contact-us/:requestId([0-9]+|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})?',
        name: 'contact-us',
    },
    NOT_FOUND: {
        path: '(.*)',
        name: 'hubs-not-found-error-page',
    },
    CSM_FOLDER: {
        path: '/folder/:folderId',
        name: 'csm-folder',
    },
    CSM_REQUEST_DETAILS: {
        path: '/user/requests/:requestKey',
        name: 'csm-request-details',
    },
    VIEW_PORTAL_ARTICLE: {
        path: `${PORTAL_ROUTE_PREFIX}/article/:articleId`,
        name: 'hubs-view-portal-kb-article',
    },
    PORTAL_ACCESS_FORBIDDEN: {
        path: '/user/forbidden',
        name: 'hubs-portal-access-forbidden',
    },
    VIEW_ARTICLE: {
        path: '/article/:articleId',
        name: 'hubs-view-kb-article',
    },
    VIEW_CROSS_SITE_PORTAL_ARTICLE: {
        path: `${PORTAL_ROUTE_PREFIX}/cloudId/:cloudId/article/:articleId`,
        name: 'hubs-view-portal-cross-site-kb-article',
    },
    VIEW_CROSS_SITE_ARTICLE: {
        path: '/cloudId/:cloudId/article/:articleId',
        name: 'hubs-view-kb-cross-site-article',
    },
    LOGIN: {
        path: '/user/login',
        name: 'hubs-login',
    },
    SIGNUP: {
        path: '/user/signup',
        name: 'hubs-user-signup',
    },
    COMPLETE_SIGNUP: {
        path: '/user/complete-signup',
        name: 'hubs-user-complete-signup',
    },
    RESET_PASSWORD: {
        path: '/user/resetpassword',
        name: 'hubs-user-reset-password',
    },
    CHECK_EMAIL: {
        path: '/user/check-email',
        name: 'hubs-user-checkmail',
    },
};
